import { render, staticRenderFns } from "./deposit-records.vue?vue&type=template&id=13dafeaa&scoped=true"
import script from "./deposit-records.vue?vue&type=script&lang=js"
export * from "./deposit-records.vue?vue&type=script&lang=js"
import style0 from "./deposit-records.vue?vue&type=style&index=0&id=13dafeaa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dafeaa",
  null
  
)

export default component.exports